import { find } from "utils/dom"
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger";
 gsap.registerPlugin(ScrollTrigger);



export default function  animationHome() {

	
	const Home = find("[js-page='home']")
	if (!Home) return

  function introBanner(){

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: "#banner",
				start: "top 90%", // inicia quando 20% do banner estiver visível
				once: true // anima só uma vez
			}
		});

		gsap.set('.banner-video', { y: '-10%'})

		// 1. Título em 3 linhas (cascata)
		tl.from(".main-text-hero span", {
			y: 60,
			opacity: 0,
			stagger: 0.15,
			duration: 1,
			ease: "power3.out"
		})

		// 2. Subtítulo com pequeno atraso após o título
		.from(".logo-banner p", {
			y: 30,
			opacity: 0,
			duration: 0.8,
			ease: "power2.out"
		}, "<+=0.5") // começa 0.3s antes de terminar o anterior

		// 3. Vídeo entra com zoom e fade
		.from(".banner-video", {
			scale: 0.95,
			opacity: 0,
			duration: 1.2,
			
			ease: "power2.out"
		}, "-=0.4"); 

	}

	function animationSections(){
		document.querySelectorAll("section").forEach(section => {
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: section,
					start: "top 85%",  // inicia quando o topo da section encosta em 85% da tela
					toggleActions: "play none none none", // anima uma vez
				}
			});

			// Anima os filhos da section com leve atraso entre eles
			tl.from(section.children, {
				y: 50,
				opacity: 0,
				duration: 1,
				ease: "power3.out",
				stagger: 0.2
			});
		});
	}

	introBanner()
	animationSections()
}